<template lang="pug">
v-content
  v-toolbar.page-header(app, flat, fixed, color='white', height='105')
    v-breadcrumbs(divider='/')
      v-breadcrumbs-item
        router-link(to='/people')
          h2 All People
      v-breadcrumbs-item(v-if='!this.$route.params.id' disabled='')
        h2.ma-0 Add Person
      v-breadcrumbs-item(v-if='this.$route.params.id')
        router-link(:to="`/people/person/${this.$route.params.id}`")
          h2.ma-0
            | {{ C.data.person.firstname }} {{ C.data.person.lastname }}
      v-breadcrumbs-item(v-if='this.$route.params.id' disabled)
        h2.ma-0 Edit

  v-container.pa-0(fluid, grid-list-lg)
    v-layout(row, nowrap)
      v-flex.pr-4
        template
          v-form(v-model='C.form.validation.overall', ref='form', lazy-validation)
            .pb-5
              .section__title.mb-5
                .subheading
                  | Member Info
              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 First name
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.user.firstname', :rules='C.form.validation.rules.user.firstname', single-line, required)

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Last name
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.user.lastname', :rules='C.form.validation.rules.user.lastname', single-line, required)

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Email
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.user.email', :rules='C.form.validation.rules.user.email', single-line, required)

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Citizenship
                v-flex(md6)
                  v-select.input--box.pt-0(v-model='C.form.selected.user.citizenship', :items='C.form.list.countries', item-text='name', item-value='alpha3')

              v-layout(row, v-if='CR.show.unreleased')
                v-flex(md3)
                  label.pl-0.mt-2 Time Zone
                v-flex(md6)
                  v-text-field.input--box.pt-0( v-model='C.form.selected.user.time_zone')
            .pb-5
              .section__title.mb-5
                .subheading
                  | Home Address
              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Street Address
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.home_address.street1')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Street Address (cont.)
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.home_address.street2')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 City
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.home_address.city')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 State/Province
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.home_address.state_province')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Postal Code
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.home_address.postal_code')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Country
                v-flex(md6)
                  v-select.input--box.pt-0(v-model='C.form.selected.home_address.country', :items='C.form.list.countries', item-text='name', item-value='alpha3')

              v-layout(row, v-if='CR.authorization.state.isGod || CR.authorization.state.isOrgAdmin')
                v-flex(md3)
                  label.pl-0.mt-2 Phone
                v-flex(md6)
                  v-text-field.input--box(v-model='C.form.selected.home_address.phone_number', label='Phone', bottom='', hide-details)

            .pb-5
              .section__title.mb-5
                .subheading
                  | Work Address
              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Employer
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.work_address.employer')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Street Address
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.work_address.street1')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Street Address (cont.)
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.work_address.street2')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 City
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.work_address.city')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 State/Province
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.work_address.state_province')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Postal Code
                v-flex(md6)
                  v-text-field.input--box.pt-0(v-model='C.form.selected.work_address.postal_code')

              v-layout(row)
                v-flex(md3)
                  label.pl-0.mt-2 Country
                v-flex(md6)
                  v-select.input--box.pt-0(v-model='C.form.selected.work_address.country', :items='C.form.list.countries', item-text='name', item-value='alpha3')

              v-layout(row, v-if='CR.authorization.state.isGod || CR.authorization.state.isOrgAdmin')
                v-flex(md3)
                  label.pl-0.mt-2 Phone
                v-flex(md6)
                  v-text-field.input--box(v-model='C.form.selected.work_address.phone_number', label='Phone', bottom='', hide-details)

        v-divider.my-3
        v-layout(row)
          v-flex(md3)
          v-flex(md6)
            v-btn.ml-0(@click='C.form.trigger.submit', :disabled='!C.form.validation.overall', color='primary')
              | {{ this.$route.params.id ? "Update" : "Add" }}
            v-btn(to='/people', exact, v-if='!this.$route.params.id')
              | Cancel
            v-btn(:to="`/people/person/${this.$route.params.id}`", exact, v-if='this.$route.params.id')
              | Cancel


      v-flex(style='position: relative; flex: 0 0 236px')
        .d-block(style='width: 220px; margin-top: 8px')
          v-layout.mb-2(column, v-if='this.$route.params.id')

            v-card.mb-3(v-if='CR.authorization.state.isGod')
              v-card-title
                div(style="width:100%")
                  h3.mb-2
                    | Global Status
                  v-select.input--box(v-model='C.form.selected.global_status', label="Status", bottom='', v-bind:items='C.form.list.globalStatuses', item-text='label', item-value='value', hide-details)
              v-card-actions.px-3.pb-3.pt-0
                v-btn.ma-0(@click='C.form.trigger.setGlobalStatus()', color='primary')
                  | Save

            v-card.mb-3(v-for='organizationStatusItem in C.data.person.user_organization_statuses', :key='organizationStatusItem.id')
              v-card-title
                div(style="width:100%")
                  h3.mb-2
                    | {{ organizationStatusItem.organization_name }}
                  v-select.input--box(v-model='organizationStatusItem.status', :label='organizationStatusItem.id === 1 ? "Master Status" : "Organization Status"', bottom='', v-bind:items='C.form.list.organizationStatuses', item-text='label', item-value='value', hide-details)
                  v-text-field.input--box(v-model='organizationStatusItem.title', label='Title', bottom='', v-if='organizationStatusItem.oa', hide-details)
                  v-text-field.input--box(v-model='organizationStatusItem.phone', label='Phone', bottom='', v-if='organizationStatusItem.oa', hide-details)

              v-card-actions.px-3.pb-3.pt-0
                v-btn.ma-0(@click='C.form.trigger.updateDataForOrganization(organizationStatusItem)', color='primary')
                  | Save
              v-divider
              v-card-text.pa-4(v-if='!organizationStatusItem.oa')
                v-layout(row, nowrap, align-start)
                  v-icon.mt-1(small, color='primary') verified_user
                  p.body-2.ml-1.mb-0
                    a(@click='C.form.trigger.convertOrganizationAdminRole(organizationStatusItem, true)')
                      | Make {{ C.data.person.firstname }} {{ C.data.person.lastname }} this organization's administrator
              v-card-text.pa-4(v-if='organizationStatusItem.oa')

                v-layout(row, nowrap, align-start)
                  v-icon.mt-1(small) person
                  p.body-2.ml-1
                    | {{ C.data.person.firstname }} {{ C.data.person.lastname }} is administrator

                v-layout(row, nowrap, align-start)
                  v-icon.mt-1(small, color='error') remove_circle
                  p.body-2.ml-1.mb-0
                    a.red--text(@click='C.form.trigger.convertOrganizationAdminRole(organizationStatusItem, false)')
                      | Remove {{ C.data.person.firstname }} {{ C.data.person.lastname }} as an administrator

            v-card.mb-2(v-if='!C.form.state.assignToOrganizationActive && (C.form.list.organizations.length !== 0 && CR.authorization.state.isGod)')
              v-card-text.pa-4
                v-layout(row, nowrap, align-start)
                  v-icon.mt-1(small, color='primary') add_circle
                  p.body-2.ml-1.mb-0
                    a.primary--text(@click='C.form.event.toggleAssignToOrganization(true)')
                      | Assign member to another org

            v-card.mb-2(v-if='C.form.state.assignToOrganizationActive && (C.form.list.organizations.length !== 0 && CR.authorization.state.isGod)')
              v-card-title
                v-select.input--box(v-model='C.form.selected.addToOrganization.organization_id', label='Select Organization', multi-line='', bottom='', v-bind:items='C.form.list.organizations', item-text='name', item-value='id', hide-details)
              v-card-actions.px-3.pb-3.pt-0
                v-btn.ml-0(@click='C.form.trigger.addToOrganization()', block, color='primary')
                  | Save
                v-btn.mr-0(@click='C.form.event.toggleAssignToOrganization(false)', block)
                  | Cancel



</template>

<script>
  import globalSettings from '../../assets/global-settings.js'
  import tools from '../../assets/tools.js'
  import axios from '../../../node_modules/axios/dist/axios.js'
  import _ from 'underscore'
  import Multiselect from 'vue-multiselect'
  import countryData from 'country-data'

  export default {
    components: {
      Multiselect
    },
    computed: {
      binding () {
        const binding = {}
        if (this.$vuetify.breakpoint.smAndDown) binding.column = true
        return binding
      }
    },
    data () {
      return {
        CR: {
          authorization: globalSettings.authorization,
          show: globalSettings.show
        },
        C: {
          data: {
            person: {}
          },
          form: {
            validation: {
              overall: false,
              rules: {
                user: {
                  firstname: [
                    (v) => !!v || 'First name is required'
                  ],
                  lastname: [
                    (v) => !!v || 'Last name is required'
                  ],
                  email: [
                    (v) => !!v || 'Email is required'
                  ]
                }
              }
            },
            state: {
              assignToOrganizationActive: false
            },
            selected: {
              user: {
                firstname: '',
                lastname: '',
                email: '',
                citizenship: '',
                time_zone: ''
              },
              home_address: {
                street1: '',
                street2: '',
                city: '',
                state_province: '',
                postal_code: '',
                country: '',
                phone_number: ''
              },
              work_address: {
                employer: '',
                street1: '',
                street2: '',
                city: '',
                state_province: '',
                postal_code: '',
                country: '',
                phone_number: ''
              },
              global_status: null,
              addToOrganization: {
                organization_id: null
              }
            },
            list: {
              organizations: [],
              roles: [],
              countries: countryData.countries.all,
              organizationStatuses: [{
                label: 'Active',
                value: 'Active'
              }, {
                label: 'Inactive',
                value: 'Inactive'
              }],
              globalStatuses: [{
                label: 'Enabled',
                value: 'Active'
              }, {
                label: 'Suspended',
                value: 'Suspend'
              }, {
                label: 'Archived',
                value: 'Delete'
              }]
            },
            event: {
              toggleAssignToOrganization: (isOpen) => {
                this.C.form.state.assignToOrganizationActive = isOpen
              }
            },
            trigger: {
              submit: () => {
                var component = this

                var submitItem = {
                  user: component.C.form.selected.user,
                  home_address: component.C.form.selected.home_address,
                  work_address: component.C.form.selected.work_address
                }

                if (component.$route.params.id) {
                  submitItem.user_id = component.$route.params.id
                }

                function completeUpdateProcess (resultsItem) {
                  console.info('User Update Results: ', resultsItem)

                  if (component.$route.params.id) {
                    component.$router.push({
                      name: 'Person',
                      params: {
                        id: component.$route.params.id
                      }
                    })

                    tools.alert({
                      type: 'success',
                      message: `${component.C.form.selected.user.firstname} ${component.C.form.selected.user.lastname} has been updated.`
                    })
                  } else {
                    component.$router.push({
                      name: 'People'
                    })

                    tools.alert({
                      type: 'success',
                      message: `${component.C.form.selected.user.firstname} ${component.C.form.selected.user.lastname} has been created.`
                    })
                  }
                }

                if (component.$route.params.id) {
                  axios.put(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/people/update`, submitItem)
                    .then(function (response) {
                      var userUpdateData = response.data

                      completeUpdateProcess({
                        user: userUpdateData
                      })
                    })
                    .catch(function (errorResponse) {
                      tools.alert({
                        type: 'error',
                        errorResponse: errorResponse
                      })
                    })
                } else {
                  axios.post(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/people/create`, submitItem)
                    .then(function (response) {
                      var userUpdateData = response.data

                      completeUpdateProcess({
                        user: userUpdateData
                      })
                    })
                    .catch(function (errorResponse) {
                      tools.alert({
                        type: 'error',
                        errorResponse: errorResponse
                      })
                    })
                }
              },
              setGlobalStatus: () => {
                var component = this

                var submitItem = {
                  user_id: component.$route.params.id,
                  status: component.C.form.selected.global_status
                }

                axios.put(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/people/update_global_status`, submitItem)
                     .then(response => {
                       console.log('setGlobalStatus() success', response.data.data)

                       tools.alert({
                         type: 'success',
                         message: `${component.C.form.selected.user.firstname} ${component.C.form.selected.user.lastname}'s global status has been updated.`
                       })
                     })
                     .catch(errorResponse => {
                       tools.alert({
                         type: 'error',
                         errorResponse: errorResponse
                       })
                     })
              },
              addToOrganization: () => {
                var component = this

                axios.post(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/user_roles/join_organization`, {
                  user_id: this.$route.params.id,
                  organization_id: this.C.form.selected.addToOrganization.organization_id
                })
                     .then(response => {
                       console.log('addToOrganization() success', response.data.data)

                       tools.getUser({
                         id: component.$route.params.id,
                         success: function (userData) {
                           tools.getOrganizationsList({
                             success: function (organizationList) {
                               component.C.data.person.user_organization_statuses = userData.user_organization_statuses

                               component.C.form.event.toggleAssignToOrganization(false)
                               component.C.event.refreshOrganizationList(organizationList)

                               tools.alert({
                                 type: 'success',
                                 message: `${component.C.form.selected.user.firstname} ${component.C.form.selected.user.lastname} has been added to the organization.`
                               })
                             }
                           })
                         }
                       })
                     })
                     .catch(errorResponse => {
                       tools.alert({
                         type: 'error',
                         errorResponse: errorResponse
                       })
                     })
              },
              convertOrganizationAdminRole: (organizationStatusItem, isPromoting) => {
                var component = this

                console.log('convertOrganizationAdminRole', {
                  organization_id: organizationStatusItem.organization_id,
                  isPromoting: isPromoting
                })

                if (isPromoting) {
                  axios.put(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/user_roles/make_oa`, {
                    user_id: this.$route.params.id,
                    organization_id: organizationStatusItem.organization_id
                  })
                       .then(response => {
                         console.log('convertOrganizationAdminRole() promote success', response.data.data)

                         organizationStatusItem.oa = true

                         tools.alert({
                           type: 'success',
                           message: `${component.C.form.selected.user.firstname} ${component.C.form.selected.user.lastname} has been promoted from organization user to administrator.`
                         })
                       })
                       .catch(errorResponse => {
                         tools.alert({
                           type: 'error',
                           errorResponse: errorResponse
                         })
                       })
                } else {
                  axios.delete(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/user_roles/remove_oa`, {
                    params: {
                      user_id: this.$route.params.id,
                      organization_id: organizationStatusItem.organization_id
                    }
                  })
                       .then(response => {
                         console.log('convertOrganizationAdminRole() demote success', response.data.data)

                         organizationStatusItem.oa = false

                         tools.alert({
                           type: 'success',
                           message: `${component.C.form.selected.user.firstname} ${component.C.form.selected.user.lastname} has been demoted from organization administrator to user.`
                         })
                       })
                       .catch(errorResponse => {
                         tools.alert({
                           type: 'error',
                           errorResponse: errorResponse
                         })
                       })
                }
              },
              updateDataForOrganization: (organizationStatusItem) => {
                var component = this

                console.log('updateDataForOrganization', {
                  organizationStatusItem: organizationStatusItem
                })

                var submitItem = {
                  user_id: this.$route.params.id,
                  organization_id: organizationStatusItem.organization_id,
                  status: organizationStatusItem.status
                }

                if (organizationStatusItem.oa) {
                  submitItem.title = organizationStatusItem.title
                  submitItem.phone = organizationStatusItem.phone
                }

                axios.put(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/people/save_organization_status`, submitItem)
                     .then(response => {
                       console.log('updateDataForOrganization() success', response.data.data)

                       tools.alert({
                         type: 'success',
                         message: `${component.C.form.selected.user.firstname} ${component.C.form.selected.user.lastname}'s organization data has been updated.`
                       })
                     })
                     .catch(errorResponse => {
                       tools.alert({
                         type: 'error',
                         errorResponse: errorResponse
                       })
                     })
              }
            }
          },
          event: {
            refreshOrganizationList: (organizationList) => {
              this.C.form.list.organizations = []

              for (var j = 0; j < organizationList.length; j++) {
                var statusOrganizationMatch = _.find(this.C.data.person.user_organization_statuses, function (userOrganizationStatusItem) {
                  return userOrganizationStatusItem.organization_id === organizationList[j].id
                })

                if (!statusOrganizationMatch) {
                  this.C.form.list.organizations.push({
                    id: organizationList[j].id,
                    name: organizationList[j].name
                  })
                }
              }
            }
          }
        }
      }
    },
    created () {
      var component = this

      if (this.$route.params.id) {
        tools.getUser({
          id: this.$route.params.id,
          success: function (userData) {
            component.C.data.person = userData

            component.C.form.selected.user.firstname = userData.firstname
            component.C.form.selected.user.lastname = userData.lastname
            component.C.form.selected.user.email = userData.email
            component.C.form.selected.user.citizenship = userData.citizenship || 'USA'
            component.C.form.selected.user.time_zone = userData.time_zone
            component.C.form.selected.home_address = userData.home_address || {}
            component.C.form.selected.work_address = userData.work_address || {}

            component.C.form.selected.home_address.country = component.C.form.selected.home_address.country || 'USA'
            component.C.form.selected.work_address.country = component.C.form.selected.work_address.country || 'USA'

            if (component.CR.authorization.state.isGod) {
              component.C.form.selected.global_status = userData.global_status || 'Active'
            }

            function runBase (dataItems) {
              var organizationList = dataItems.organizations

              component.C.event.refreshOrganizationList(organizationList)
            }

            tools.getOrganizationsList({
              success: function (organizationList) {
                runBase({
                  organizations: organizationList
                })
              }
            })
          }
        })
      }
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .side-drawer {
    background-color: transparent;
  }
  h3 {
    line-height: 1.2
  }
</style>



// WEBPACK FOOTER //
// src/components/People/Add.vue